import styles from './index.less';
import { useModel } from '@umijs/max';
import defaultUrl from '@/assets/user/defaultImage.png';
import { Edit } from '@react-vant/icons';
import { Button, Cell, Form, Input, Toast } from 'react-vant';
import { useSafeState } from 'ahooks';
import { ModifyOwnerDetailParams } from '@/pages/Mine/interface';
import { useEffect } from 'react';
import { queryUpdateOwnerDetail } from '@/service/house';

const PersonData = () => {
  const { userInfo } = useModel('useGlobal', (model) => ({
    userInfo: model.userInfo,
    wechatAccountInfo: model.wechatAccountInfo,
  }));
  const { ownerInformation, queryInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation,
      queryInformation: model.queryInformation,
    }),
  );
  const [form] = Form.useForm();
  const [editVisible, setEditVisible] = useSafeState<boolean>(false);

  const onFinish = (value: any) => {
    const data: ModifyOwnerDetailParams = {
      ...value,
      sequenceNbr: ownerInformation?.sequenceNbr,
      openId: ownerInformation?.openId,
    };
    queryUpdateOwnerDetail(data).then((res) => {
      if (res?.code === 200) {
        Toast.success('修改成功');
        queryInformation();
        setEditVisible(false);
      }
    });
  };

  useEffect(() => {
    if (ownerInformation) {
      form.setFieldsValue({
        nickName: ownerInformation?.nickName,
        phonenumber: ownerInformation?.phonenumber,
        email: ownerInformation?.email,
        idNumber: ownerInformation?.idNumber,
      });
    }
  }, [ownerInformation]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.userInfo}>
          <div>
            <img src={userInfo?.headimgurl || defaultUrl} alt={'user'} />
            <p>{userInfo?.nickname}</p>
          </div>
          {!editVisible && (
            <Edit
              onClick={() => setEditVisible((prevState) => !prevState)}
              fontSize={20}
              style={{ marginTop: 14 }}
            />
          )}
        </div>
      </div>
      <div className={styles.title}>个人信息</div>
      {editVisible ? (
        <Form
          className={styles.formContainer}
          form={form}
          onFinish={onFinish}
          footer={
            <div style={{ margin: 16 }}>
              <Button round nativeType="submit" type="primary" block>
                确认修改
              </Button>
            </div>
          }
        >
          <Form.Item label={'真实姓名'} name={'nickName'}>
            <Input placeholder={'请输入真实姓名'} />
          </Form.Item>
          {/*<Form.Item label={'性别'} isLink></Form.Item>*/}
          <Form.Item label={'手机号码'} name={'phonenumber'}>
            <Input placeholder={'请输入手机号码'} />
          </Form.Item>

          <Form.Item label={'证件号码'} name={'idNumber'}>
            <Input placeholder={'请输入证件号码'} />
          </Form.Item>
          <Form.Item label={'邮箱'} name={'email'}>
            <Input placeholder={'请输入邮箱'} />
          </Form.Item>
        </Form>
      ) : (
        <Cell.Group card>
          <Cell title={'真实姓名'} value={ownerInformation?.nickName} />
          <Cell title={'手机号'} value={ownerInformation?.phonenumber} />
          <Cell title={'身份证号'} value={ownerInformation?.idNumber} />
          <Cell title={'邮箱'} value={ownerInformation?.email} />
        </Cell.Group>
      )}
    </div>
  );
};

export default PersonData;
